import { Injectable, Optional } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { JwtAuthService } from "../services/jwt-auth.service";
import { LocalStoreService } from "app/shared/services/local-store.service";
import { LoginData } from "app/models";
import { environment } from "environments/environment";
import { OAuthModuleConfig, OAuthStorage } from "angular-oauth2-oidc";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  JWT_TOKEN = "JWT_TOKEN";
  JWT_TOKEN_REFRESH = "JWT_TOKEN_REFRESH";

  constructor(
    private ls: LocalStoreService,
    private jwtAuth: JwtAuthService,
    private authStorage: OAuthStorage,
    @Optional() private moduleConfig: OAuthModuleConfig
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const user: LoginData = this.jwtAuth.getUser();

    if (!environment.enableSSO) { // Regularno bez SSO
      if (!user || !user.token) {
        // Do not add anything to headers for Login or if user or token doesn't exist
      } else {
        if (request.url.includes('TokenRefresh')) {
          // For token refresh add both token and refresh token
          const refreshToken = this.ls.getItem(this.JWT_TOKEN_REFRESH);
          if (refreshToken) {
            request = this.addTokenAndRefreshToken(request, user.token, refreshToken);
          } else {
            request = this.addTokenAndRefreshToken(request, user.token, user.refreshToken);
          }
        } else {
          // For everything else just add token
          request = this.addToken(request, user.token);
        }
      }
    } 
    else {  // SSO authorization bearer
      // URL je deklarisan kao resource/api url pa mu  dodajemo access_token sso-a
      const url = request.url.toLowerCase();
      const token = this.authStorage.getItem('access_token');
      const refreshToken = this.authStorage.getItem('refresh_token');

      if (!!this.moduleConfig &&
        !!this.moduleConfig.resourceServer &&
        !!this.moduleConfig.resourceServer.sendAccessToken &&
        !!this.moduleConfig.resourceServer.allowedUrls
      ) {

        const isSSOAuthEndpoint = request.url.includes('PrijavaJedinstveniIdentifikator');

        if (!!!user || !!!user.token || isSSOAuthEndpoint) {

          const token = this.authStorage.getItem('access_token');
          const refreshToken = this.authStorage.getItem('refresh_token');

          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
              RefreshToken: `${refreshToken}`
            }
          });
        } else if (user && !!user.token) {
          request = this.tokenRefresh(request, user, user.token, user.refreshToken);
        }
      }
    }
    return next.handle(request);
  }

  // For token refresh - add both token and refresh token
  private tokenRefresh(request: HttpRequest<any>, user: LoginData, token: string, refreshToken: string): HttpRequest<any> {
    if (refreshToken != null) {
      return this.addTokenAndRefreshToken(request, token, refreshToken);
    } else {
      return this.addTokenAndRefreshToken(request, user.token, user.refreshToken);
    }
  }

  private addTokenAndRefreshToken(request: HttpRequest<any>, token: string, refreshToken: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        RefreshToken: `${refreshToken}`
      }
    });
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
}